<template>
    <p>{{ textForAddAttachmentLabel == null ? '+' : textForAddAttachmentLabel }}</p>
    <input type="file" @change="onFileInputChange" @cancel="onFileInputCancel" ref="fileUploader" style="display: none;"
        :accept="extensionesSoportadas" />
    <DxButton :text="textForAddAttachmentButton" @click="onAnadirAdjunto" :visible="puedeAnadir"></DxButton>

    <template v-for="(fichero, key) in ficheros" :key="fichero.id">
        <FileUploader v-if="fichero.status !== 'deleted'" :fichero="ficheros[fichero.id]"
            :supportedExtensions="props.supportedExtensions"
            :textForAddAttachmentLabel="props.textForAddAttachmentLabel"
            :textForAddAttachmentButton="props.textForAddAttachmentButton"
            :textForNonDownloadableFiles="props.textForNonDownloadableFiles" @fileRemoveRequested="onFileRemoved(key)"
            @fileReplaceRequested="() => onFileReplaceRequest(fichero)"
            @fileDownloadRequested="() => onFileDownloadRequested(fichero)" />
    </template>

    <!-- v-model:fichero="ficheros[fichero.id]" == props (fichero) + @update:fichero="" // se dispara cuando cambie el valor de props, es decir, fichero -->

</template>

<script setup lang="ts">
import { DxButton } from 'devextreme-vue';
import { set, uniqueId } from 'lodash';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import FileUploader from './FileUploader.vue';




const ficheros = defineModel<Ficheros>("ficheros", { required: true });
const extensionesSoportadas = computed(() => props.supportedExtensions?.join(",") ?? "*.*");
const emit = defineEmits<{
    (e: "update:ficheros", value: Ficheros): void;
    (e: "fileDownloadRequested", value: Fichero): void;
}>();

const props = defineProps<{
    maxFiles?: number,
    supportedExtensions?: string[],
    textForAddAttachmentLabel: string,
    textForAddAttachmentButton: string,
    textForNonDownloadableFiles: string
}>()




const numFicheros = ref<number>(0);
const puedeAnadir = computed(() => props.maxFiles == null || numFicheros.value < props.maxFiles);
const onFileInputChange = ref<(e: Event) => void>();
const onFileInputCancel = ref<(e: Event) => void>();
const fileUploader = ref<HTMLInputElement>();


function onAnadirAdjunto() {
    onFileInputChange.value = (e) => addFile((e.currentTarget as HTMLInputElement).files![0]);
    onFileInputCancel.value = () => { };
    fileUploader.value!.value = "";
    fileUploader.value!.click();
}

function addFile(file: File) {
    const nuevoId = uniqueId("nuevo_");
    const nuevo = {
        id: nuevoId,
        file: file,
        fileName: file.name,
        isRemote: false,
        status: "new"
    } as Fichero;

    setFichero(nuevo);
    numFicheros.value++;
}

function onFileDownloadRequested(fichero: Fichero) {
    emit("fileDownloadRequested", fichero);
}

function onFileRemoved(id: string) {
    ficheros.value[id].status = "deleted";
    ficheros.value[id].file = null;
    numFicheros.value--;
    emit("update:ficheros", ficheros.value);
}

function setFichero(fichero: Fichero) {
    ficheros.value[fichero.id] = fichero;
    emit("update:ficheros", ficheros.value);
}

function onFileReplaceRequest(fichero: Fichero) {
    onFileInputChange.value = (e) => replaceFile(fichero, (e.currentTarget as HTMLInputElement).files![0]);
    onFileInputCancel.value = () => { };
    fileUploader.value!.value = "";
    fileUploader.value!.click();

}

function replaceFile(fichero: Fichero, file: File) {
    fichero.file = file;
    fichero.fileName = file.name;
    fichero.isRemote = false;
    fichero.status = "modified";
    setFichero(fichero);

}

</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";
</style>